function toBase64(value) {
  return value.replace(/-/g, "+").replace(/_/g, "/");
}

export function getJwtExpirationDate(token) {
  try {
    const payloadPart = token?.split(".")?.[1];
    if (!payloadPart) return null;
    const payload = JSON.parse(atob(toBase64(payloadPart)));
    if (!payload?.exp) return null;
    return new Date(payload.exp * 1000);
  } catch (_) {
    return null;
  }
}

export function setCookie(name, value, options = {}) {
  const { days = 7, expiresAt, maxAgeSeconds, sameSite = "Strict", secure } = options;
  const defaultExpires = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
  const resolvedExpires = expiresAt instanceof Date ? expiresAt : defaultExpires;
  const isLocalhost = ["localhost", "127.0.0.1"].includes(window?.location?.hostname);
  const shouldUseSecure = typeof secure === "boolean" ? secure : !isLocalhost;
  const secureFlag = shouldUseSecure ? "; Secure" : "";

  const computedMaxAge = Number.isFinite(maxAgeSeconds)
    ? maxAgeSeconds
    : Math.max(0, Math.floor((resolvedExpires.getTime() - Date.now()) / 1000));
  const maxAge = Number.isFinite(computedMaxAge) ? `; Max-Age=${computedMaxAge}` : "";

  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${resolvedExpires.toUTCString()}; path=/; SameSite=${sameSite}${secureFlag}${maxAge}`;
}

export function getCookie(name) {
  const nameEq = `${name}=`;
  const cookies = document.cookie ? document.cookie.split(";") : [];

  for (let i = 0; i < cookies.length; i += 1) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEq) === 0) {
      return decodeURIComponent(cookie.substring(nameEq.length, cookie.length));
    }
  }

  return null;
}

export function removeCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
}
